"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledErrorDropdownWrapper = exports.StyledDisabledDropdownWrapper = exports.StyledMasterDropdownWrapper = exports.StyledDropdownContent = exports.StyledDropdownItem = exports.StyledDropdownTitle = void 0;
const theme_1 = require("@icr-ui/theme");
const styled_components_1 = __importStar(require("styled-components"));
const general_1 = require("../../general");
exports.StyledDropdownTitle = (0, styled_components_1.default)(general_1.Typography) `
  margin-bottom: 0;

  & ~ svg {
    transition: transform 0.2s ease-in-out;
    margin-top: 0.6rem;
    transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
  }
`;
exports.StyledDropdownItem = (0, styled_components_1.default)(general_1.Typography) `
  ${({ index, itemSelected }) => {
    const isActive = index === itemSelected;
    return (0, styled_components_1.css) `
      width: 100%;
      padding: ${theme_1.spacings.s4};
      transition: all 0.2s ease-out;
      color: ${isActive ? theme_1.primary.light : theme_1.primary.darker};
      & + & {
        border-top: 1px solid ${theme_1.grayScale[100]};
      }
      ${!isActive &&
        (0, styled_components_1.css) `
        &:hover {
          background-color: #cfdae1;
          color: ${theme_1.primary.dark};
        }
      `}
    `;
}}
`;
exports.StyledDropdownContent = (0, styled_components_1.default)(general_1.Flexbox) `
  position: absolute;
  top: 4.7rem;
  left: 5px;
  max-height: 0;
  width: calc(100% - 10px);
  z-index: 999;
  overflow: hidden auto;
  background-color: white;
  transition: max-height 0.2s linear;
  box-shadow: ${theme_1.defaultTheme.shadows.default(theme_1.primary.darker)};
  border-radius: 0px 0px ${theme_1.spacings.s2} ${theme_1.spacings.s2};

  * {
    opacity: 0;
    transition: opacity 0.2s linear;
  }
`;
exports.StyledMasterDropdownWrapper = (0, styled_components_1.default)(general_1.Flexbox) `
  ${({ isOpen, error, customStyles }) => {
    return (0, styled_components_1.css) `
      position: relative;
      padding: 5px;
      width: 100%;

      transition: all 0.2s ease-out;
      & > div {
        cursor: pointer;
      }

      & > p ~ div:first-of-type {
        border-bottom-width: 2px;
        border-bottom-style: solid;
        border-bottom-color: ${isOpen ? theme_1.primary.light : error ? theme_1.system.error : theme_1.grayScale[600]};
        height: 45px;
        margin-bottom: ${error ? theme_1.spacings.s3 : 0};
        &:hover {
          border-bottom-color: ${theme_1.primary.dark};
        }
      }

      &:focus-within:focus-visible {
        border-bottom-color: ${theme_1.primary.dark};
        border-radius: 4px;
        box-shadow: ${theme_1.shadows.containedFocus(theme_1.primary.dark, theme_1.primary.dark)};

        ${exports.StyledDropdownTitle} {
          color: ${theme_1.primary.darker};
        }

        svg polyline {
          stroke: ${theme_1.primary.dark};
        }
        & > p ~ div:first-of-type {
          border-bottom-color: ${theme_1.primary.dark};
        }
      }

      span, input ~ button  {
        rotate: ${isOpen ? '180deg' : '0deg'};
        transition: all 0.2s ease-in-out;
      }

        ${isOpen &&
        (0, styled_components_1.css) `
        ${exports.StyledDropdownContent} {
          max-height: 400px;
          * {
            opacity: 1;
          }
        `}
      }
      & input {
        height: 45px;
        border-bottom: 1px solid transparent;
        margin: -5px -5px -5.5px -5px;
        background: transparent;
        &:hover, &:focus, &:active, &:target {
          border-bottom: 1px solid transparent;
        }
        & ~ button {
          top: 13.4px;
          right: -16.5px;
        }
      }
      ${customStyles}
    `;
}}
`;
exports.StyledDisabledDropdownWrapper = (0, styled_components_1.default)(exports.StyledMasterDropdownWrapper) `
  ${() => {
    const defaultColor = theme_1.grayScale[300];
    const disabledStyles = (0, styled_components_1.css) `
      ${exports.StyledDropdownTitle} {
        color: ${defaultColor};
      }

      ${exports.StyledDropdownContent} {
        opacity: 0;
      }

      & > p ~ div:first-of-type {
        border-bottom-color: ${defaultColor};
        &:hover {
          border-bottom-color: ${defaultColor};
        }
      }
      svg polyline {
        stroke: ${defaultColor};
      }
    `;
    return (0, styled_components_1.css) `
      user-select: none;
      pointer-events: none;
      cursor: not-allowed;
      ${disabledStyles}
      &:hover {
        ${disabledStyles}
      }
    `;
}}
`;
exports.StyledErrorDropdownWrapper = (0, styled_components_1.default)(exports.StyledMasterDropdownWrapper) `
  ${() => {
    const disabledStyles = (0, styled_components_1.css) `
      border-bottom-color: ${theme_1.system.error};

      ${exports.StyledDropdownTitle} {
        color: ${theme_1.system.error};
      }
    `;
    return (0, styled_components_1.css) `
      ${disabledStyles}
      &:hover {
        ${disabledStyles}
      }
    `;
}}
`;
//# sourceMappingURL=styles.js.map